import * as React from 'react';
import { SVGProps } from 'react';

const SvgFeeds = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.426.133a.75.75 0 0 0-.852 0l-7.25 5A.75.75 0 0 0 0 5.75v7.5A2.75 2.75 0 0 0 2.75 16h10.5A2.75 2.75 0 0 0 16 13.25v-7.5a.75.75 0 0 0-.324-.617l-7.25-5ZM1.5 13.25V6.144L8 1.66l6.5 4.483v7.106c0 .69-.56 1.25-1.25 1.25H11v-2.751a2.75 2.75 0 0 0-2.75-2.75h-.5A2.75 2.75 0 0 0 5 11.749V14.5H2.75c-.69 0-1.25-.56-1.25-1.25Zm5-1.501c0-.69.56-1.25 1.25-1.25h.5c.69 0 1.25.56 1.25 1.25v2.75h-3v-2.75Z"
      fill="#174174"
    />
  </svg>
);

export default SvgFeeds;
